// 应用配置文件
export const APP_CONFIG = {
    // 版本信息
    VERSION: {
        NUMBER: "1.0.5",
        BUILD_DATE: "2025-06-17",
        NAME: "贝叶斯AI性格测试系统"
    },

    // 语音配置
    SPEECH: {
        LANG: 'zh-CN',
        RATE: 1.0,
        PITCH: 1.0
    },

    // 倒计时配置
    COUNTDOWN: {
        PHOTO_COUNTDOWN: 3,      // 拍照倒计时（秒）
        AUTO_RETURN_TIME: 60,    // 自动返回首页时间（秒）
        FACE_CHECK_INTERVAL: 3000 // 人脸检测间隔（毫秒）
    },

    // 动画配置
    ANIMATION: {
        PROGRESS_UPDATE_INTERVAL: 200,  // 进度条更新间隔（毫秒）
        PROGRESS_MAX: 80,              // 进度条最大值
        PROGRESS_INCREMENT: 2,         // 进度条增量
        COUNTDOWN_INTERVAL: 1500       // 拍照倒计时间隔（毫秒）
    },

    // 图片配置
    IMAGE: {
        CAPTURE_FORMAT: 'image/jpeg',
        CAPTURE_QUALITY: 0.8,
        PREVIEW_FORMAT: 'image/png'
    },

    // 页面状态
    PAGES: {
        HOME: 'home',
        CAPTURE: 'capture',
        LOADING: 'loading',
        RESULT: 'result'
    },

    // 语音提示文本
    MESSAGES: {
        WELCOME: "欢迎使用贝叶斯性格测试系统",
        RETAKE: "重新拍摄，请眼睛看向摄像头，保持姿势",
        ANALYZING: "正在分析您的面部特征，请稍候",
        PREPARE_CAPTURE: "准备拍摄，请眼睛看向摄像头，保持姿势",
        CAPTURE: "拍摄",
        ANALYSIS_COMPLETE: "您的性格分析报告已完成，如需重新测试，请点击重新采集",
        ANALYSIS_FAILED: "分析失败，请重试",
        AUTO_RETURN: "自动返回首页"
    },

    // 错误消息
    ERRORS: {
        CAMERA_ACCESS: "无法访问摄像头，请检查权限设置",
        VIDEO_INVALID: "视频流无效",
        IMAGE_CAPTURE_FAILED: "图片捕获失败",
        OSS_TOKEN_FAILED: "获取OSS Token失败",
        UPLOAD_FAILED: "上传失败"
    }
};

// UI文案配置 - 修改这里的内容即可改变页面文案
export const UI_TEXTS = {
    // 网页基础信息
    TITLE: "贝叶斯AI性格测试系统",
    KEYWORDS: "贝叶斯AI性格测试系统,面部扫描,性别分析,年龄分析,BMI分析,性格分析,职业建议,AI智能,性格测试",
    DESCRIPTION: "贝叶斯AI性格测试系统：快速面部扫描，AI秒级解析您的性别、年龄、BMI，并洞察性格特质，生成专属职业发展建议。前沿贝叶斯算法驱动，开启科学自我认知之旅。免费体验！",

    // 首页文案
    HOME_LOGO: "贝叶斯性格测试系统",
    HOME_SUBTITLE: "AI PERSONALITY TEST", 
    START_BUTTON: "开始面部采集",
    COPYRIGHT: "© 2025 贝叶斯AI智能系统 | 基于人工智能技术",

    // 采集页面文案
    CAPTURE_TITLE: "面部信息采集",
    CAPTURE_SUBTITLE: "FACE CAPTURE",
    INSTRUCTION_1: "请眼睛看向摄像头，保持面部在圆形扫描框内",
    INSTRUCTION_2: "确保环境光线充足",
    RETAKE_BUTTON: "重新拍摄",
    START_ANALYSIS_BUTTON: "开始分析",

    // 分析页面文案
    LOADING_TITLE: "分析中，请稍候...",
    LOADING_SUBTITLE: "正在使用AI算法分析您的面部特征",
    LOADING_FOOTER: "正在使用AI神经网络进行分析..."
};

// 默认用户头像SVG
export const DEFAULT_AVATAR = `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'><circle cx='100' cy='100' r='80' fill='%231a203a'/><circle cx='100' cy='80' r='25' fill='%230c0f1d' stroke='%2340e0d0' stroke-width='2'/><path d='M60,130 Q100,150 140,130' stroke='%2340e0d0' stroke-width='3' fill='none'/><circle cx='70' cy='80' r='5' fill='%2300f2fe'/><circle cx='130' cy='80' r='5' fill='%2300f2fe'/></svg>`;

// 默认分析数据模板 - 性格测试
export const DEFAULT_ANALYSIS_DATA = {
    gender: "男",
    age: "25",
    bmi: "23",
    health: "85",
    features: [
        { title: "理性思维", content: "表现出理性分析和逻辑思考的倾向，面对问题更偏向于理性判断" },
        { title: "专注严谨", content: "神态和整体状态透露出专注特质，对待事务可能具有严谨的态度" },
        { title: "责任感强", content: "沉稳的形象体现出对责任的重视，在工作生活中更具担当意识" },
        { title: "内向思考型", content: "整体气质偏向于内向，更习惯通过内在思考来处理信息和决策" }
    ],
    careerSuggestions: [
        { title: "软件工程师", content: "理性思维与专注严谨的特质，适合在技术领域通过逻辑分析解决编程问题" },
        { title: "数据分析师", content: "专注严谨和理性思维能够助力在数据领域精准分析、挖掘信息价值" },
        { title: "科研人员", content: "责任感强与理性思考的特点，匹配科研工作中对严谨性和长期钻研的要求" },
        { title: "教育工作者", content: "责任感强和沉稳特质，能在教育领域传递知识并关注学生成长" }
    ]
};

 